/**
 * Footer Component
 * 
 * Main site footer containing company information, social links,
 * locations, and copyright information
 */

// ==================== EXTERNAL DEPENDENCIES ====================
import React from "react"
import { Link } from "gatsby"
import { Container, Grid } from "@material-ui/core"
import ScrollToTop from "react-scroll-to-top"

// Material-UI Icons
import FacebookIcon from "@material-ui/icons/Facebook"
import TwitterIcon from "@material-ui/icons/Twitter"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import { Instagram } from "@material-ui/icons"

// ==================== INTERNAL COMPONENTS ====================
import Locations from "./../locations"
import ScrollTop from "./scroll-top"

// ==================== ASSETS ====================
import Logo from "../../images/footer_logo.png"

// ==================== COMPONENT DEFINITION ====================
/**
 * Footer Component
 * Renders the site footer with company info and navigation
 */
export default function Footer() {
  return (
    <>
      <footer>
        {/* ========== Main Footer Section ========== */}
        <div className="black-gradient white-text">
          <Container className="py-40" maxWidth="xl">
            <Grid container className="flex justify-between">
              {/* Company Info & Social Links */}
              <Grid item md={6} sm={12}>
                <Link to="/">
                  <img src={Logo} className="logo" alt="PROS Marketing Logo" />
                </Link>
                
                <p>
                  Pros Marketing is dedicated to maintaining its small business,
                  customer-focused roots while expanding services to empower our
                  clients and customers on a global scale.
                </p>
                
                {/* Social Media Icons */}
                <p className="flex mt-5 social-icons justify-center md:justify-start">
                  <a
                    href="https://www.facebook.com/PROSMARKETING/"
                    target="_blank"
                    rel="noreferrer"
                    className="mr-5"
                    title="Visit us on Facebook"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href="https://twitter.com/prosmarketing"
                    target="_blank"
                    rel="noreferrer"
                    className="mr-5"
                    title="Visit us on Twitter"
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href="https://www.instagram.com/prosmarketing/"
                    target="_blank"
                    rel="noreferrer"
                    className="mr-5"
                    title="Visit us on Instagram"
                  >
                    <Instagram />
                  </a>
                </p>
              </Grid>
              
              {/* Locations Section */}
              <Grid item md={5} xs={12}>
                <Locations />
              </Grid>
            </Grid>
          </Container>
        </div>
        
        {/* ========== Footer Bottom Section ========== */}
        <div className="blue-bg footer-bottom white-text py-12">
          <Container className="md:flex md:justify-between">
            {/* Copyright & Legal Links */}
            <p>
              Copyright &copy; 2020-2025 Pros Marketing All rights reserved.{" "}
              <span>
                | <Link to="/privacy-policy">Privacy Policy</Link>
              </span>
            </p>
            
            {/* Scroll to Top Button */}
            <ScrollToTop
              smooth
              className="scroll-top"
              component={<ScrollTop />}
              style={{
                position: "initial",
                width: "auto",
                background: "transparent",
              }}
            />
          </Container>
        </div>
      </footer>
    </>
  )
}